import { FooterTextLink } from '../FooterLink'

export const footerData: FooterTextLink[] = [
  {
    href: 'https://flow.page/privacy-policy', // Cloudflare redirects to https://www.flowcode.com/terms/privacy-policy - This is necessary to prevent backlinking from the flow.page domain to the flowcode.com domain per Google guidelines
    label: 'Privacy Policy'
  },
  {
    href: 'https://flow.page/terms-of-use', // Cloudflare redirects to https://www.flowcode.com/terms/terms-of-use - This is necessary to prevent backlinking from the flow.page domain to the flowcode.com domain per Google guidelines
    label: 'Terms of Use'
  }
]
